module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABZ0lEQVQ4jbWS3UoCQRTHf4VK7IWCsCiooV4o7HbhXVvQGwT1Jj1LLxDdBl1Y0BsEuXfeC360LeyKgghqqFCcgbU11ySiPwwzc2bOb87H7NXr9Q/+oFiUa7FYxDRNms0mi8VC2ebzOaPRaOPuBkCcK5UK4/GYcrmsbOl0Gt/3aTQaPwMsyyKTydDpdFgul8qWTCbVPJ1OMQyDXq/HZDKJBrTbbYbDIfF4fGWTSGSI8vk8g8FgO6Df75PNZkmlUhuhisLgSIDI8zw1oiSF3QmoVqtfh7GYenU2m6m91EW6sRWQy+VUDQJJCyVv27bRdZ1CoUAikVgD7Ic30japdvB6q9VSHdE0jVqthuM4ag5D1iKQ3LvdropELpZKpdWZwFzXVetwGv/zleXfAC+AI48Ah8AxoO0CPAPXwKNE+u3sALgAroCTwBgU8RU4B86A+whn0TtwB5wCl8BbALgBjoCnX6T+IP8KuP0En/CDkWlAPdsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/urgent.png
// module id = xDcF
// module chunks = 106